export function FloodIndexTemplate(params) {
    return `<table class="esri-widget__table" summary="List of attributes and values">
          <tbody>
              <tr>
                  <th class="third">Panel</th>
                  <td class="two-third">{PANEL}</td>
              </tr>
              <tr>
                  <th class="third">Attached File</th>
                  <td class="two-third">
                      <a target="_blank" href="https://www.dmcgis.com/images/Flood/{FIRM_PAN}.png" class="ui fluid tiny button">View Image</a>
                  </td>
              </tr>
          </tbody>
      </table>`;
  }
  